import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DescribeChannelModeratedByAppInstanceUser } from "../schemas/schemas_0";
export { $Command };
export class DescribeChannelModeratedByAppInstanceUserCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "DescribeChannelModeratedByAppInstanceUser", {})
    .n("ChimeSDKMessagingClient", "DescribeChannelModeratedByAppInstanceUserCommand")
    .sc(DescribeChannelModeratedByAppInstanceUser)
    .build() {
}
